import { useState } from 'react';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { Form } from '@/components/ui/form';
import { formSchema } from '../_validator';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog';

import SpinnerButton from '@/components/common/SpinnerButton';
import Error from '@/components/common/Error';
import FormGeneral from './common/FormGeneral';
import { usePutFee, useFees } from '@/data/fee';

const EditFeeDialog = ({ fee, setOpen }) => {
  const [apiError, setApiError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const putFee = usePutFee();
  const fees = useFees();
  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      label: fee.label,
      value: (fee.value / 100).toString(),
      type: fee.type
    }
  });

  const onSubmit = async (values) => {
    setSubmitting(true);
    try {
      setApiError('');
      const payload = {
        ...values,
        value: Math.round(parseFloat(values.value) * 100)
      };
      const updatedFee = await putFee(fee.id, payload);
      await fees.mutate(
        (currentFees) =>
          currentFees.map((f) => (f.id === fee.id ? updatedFee : f)),
        false
      );
      setSubmitting(false);
      setOpen(false);
    } catch (err) {
      setApiError(err.message);
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={true} onOpenChange={setOpen}>
      <DialogContent className="w-[600px]">
        <DialogHeader>
          <DialogTitle>Edit {fee.label} Fee</DialogTitle>
          <DialogDescription>Edit existing fee or rate</DialogDescription>
        </DialogHeader>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
            <FormGeneral />
            {apiError && <Error error={apiError} />}
            <DialogFooter>
              <SpinnerButton loading={submitting}>Save</SpinnerButton>
            </DialogFooter>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
};

export default EditFeeDialog;
